module.exports = __webpack_public_path__ + "static/media/img1.4393f95c.jpeg";